angular.module('guest')
.controller('ActivateGuestReferralController', ['$scope', '$state', '$stateParams', 'User',
    function($scope, $state, $stateParams, User){

        User.activateGuestReferral({activation_token: $stateParams.activation_token}, function(success) {
            $state.go('guestReferralActivated', {referral: success.referral});
        }, function(failure){
            $state.go('error_page', {error_key: failure.data.errors});
        });

    }])
.controller('GuestReferralActivatedController', ['$scope', '$stateParams', 'destinationNameFilter',
    function($scope, $stateParams, destinationNameFilter){
        // Populated when arriving from activation; empty on a direct visit/refresh,
        // in which case the template keeps the generic wording.
        $scope.destinationLabel = destinationNameFilter($stateParams.referral);
    }]);